import TraitsApiService from '../TraitsApiService';
import { ApiResponse } from '../types';

export const fetchTraitsCategories = async (context: string): Promise<ApiResponse<any>> =>
  new TraitsApiService({ version: 'v1' }).setEndpoint(`/options`).setParams({ context }).get();

export const getTraitCategoryScores = async (data: any): Promise<ApiResponse<any>> =>
  new TraitsApiService({ version: 'v1' }).setEndpoint(`/scores`).setBody(data).post();

export const getRecommendedAudience = async (id: string) =>
  new TraitsApiService({ version: 'v1' })
    .setEndpoint('/recommendAudience')
    .setParams({ dashboard_ids: id })
    .get();
